import styled from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint } from 'react-components'

import ExternalLink from '../../../common/external-link'

export const Container = styled.div`
    margin-top: 0.5rem;
    cursor: pointer;
    height: 100%;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;
`

export const InnerContainer = styled.div`
    position: ${props => props.theme.style.position.relative};
    transition: box-shadow 200ms ease-out;
    padding: 0.75rem;
    background-color: #f5f5f5;
    margin-right: 1.25rem;
    height: 100%;
    border-radius: 0.5rem;

    display: flex;
    flex-direction: column; /* important */
    justify-content: space-between; /* distributes sections */

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 1rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        max-width: 23.9375rem;
        margin-right: 0;
    }
`

export const TopContainer = styled.div`
    display: ${props => props.theme.style.display.flex};
    padding-bottom: 1rem;
    border-bottom: 1px solid ${props => props.theme.colors.tfwBlackOpacity10};
`

export const ImageContainer = styled.div`
    height: 4.5rem !important;
    width: 4.5rem !important;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        height: 7rem !important;
        width: 7rem !important;
    }

    img {
        border-radius: ${props => props.theme.typography.border.radius.small};
    }
`

export const ApartmentInfoContainer = styled.div`
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.column};
    margin-right: 1rem;
    font-family: ${props => props.theme.typography.font.family.lato};
    flex: 1;
    width: 66%;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        justify-content: flex-start;
    }
`

export const ApartmentInnerContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
`

export const ApartmentTitle = styled.h3`
    /* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.375rem;
    margin: 0.25rem 0 0;
    color: #282828;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    /* stylelint-enable value-no-vendor-prefix, property-no-vendor-prefix */

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: 1.25rem;
        line-height: 1.75rem;
    }
`

export const RegionSeoHref = styled(ExternalLink)`
    font: inherit;
    text-decoration: none;
    color: #5f5f5f;
`

export const SeoHref = styled(ExternalLink)`
    font: inherit;
    text-decoration: none;
`

export const IconContainer = styled.div`
    width: 1rem;
    height: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        height: 1.5rem;
    }
`

export const ApartmentRegion = styled.span`
    font-family: ${props => props.theme.typography.font.family.lato};
    font-weight: 500;
    font-size: 0.6875rem;
    line-height: 1rem;
    color: #5f5f5f;
    text-transform: uppercase;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: 0.4px;

    white-space: normal;
`

export const RatingContainer = styled.div`
    display: flex;
    margin-top: 0.75rem;
`
export const StarIcon = styled.img`
    width: 1rem;
    height: 1rem;
`

export const ApartmentRating = styled.div`
    display: flex;
    align-items: center;
    font-family: ${props => props.theme.typography.font.family.lato};
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1rem;
    margin-left: 0.25rem;
    white-space: nowrap;
    overflow: ${props => props.theme.style.overflow.hidden};
    text-overflow: ellipsis;
`

export const ReviewContainer = styled.div`
    /* stylelint-disable */
    flex: 1;
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.375rem;
    margin: 0.5rem 0;
    min-height: 11rem;
    max-height: 11rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 9;
    -webkit-box-orient: vertical;
    /* stylelint-enable */
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: 0.875rem;
        margin: 1rem 0 0.5rem;
        line-height: 22px;
        -webkit-line-clamp: 8;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin: 1rem 0;
    }
`

export const ReviewText = styled.p`
    margin: 0;
    display: inline;
    color: #282828;
`

export const FooterContainer = styled.div`
    display: ${props => props.theme.style.display.flex};
    min-height: 2.5rem;
    max-height: 2.5rem;
    justify-content: space-between;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        min-height: 2rem;
        max-height: 2rem;
    }
`
export const ReviewerContainer = styled.div`
    font-family: ${props => props.theme.typography.font.family.lato};
    display: flex;
    flex-direction: column;
    white-space: nowrap;
    overflow: ${props => props.theme.style.overflow.hidden};
    text-overflow: ellipsis;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: auto;
    }
`

export const UserInfo = styled.div`
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.375rem;
    padding: 0.5rem 0;
    white-space: nowrap;
    overflow: ${props => props.theme.style.overflow.hidden};
    text-overflow: ellipsis;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: ${props => props.theme.typography.font.size.medium};
        line-height: 1.5rem;
    }
`
